'use client';

import { useMemo } from 'react';

import {
  CategoryDesktopLayoutTemplate,
  CategoryMobileLayoutTemplate
} from 'components/atomic/template';
import { DEVICE_SURFACE } from 'config/common';
import { GetUiDeviceSurface } from 'helpers/screenResolutionHelper';
import { getPageURL, ROUTE_CONFIG } from 'services/hostPortal.service';

const ChildSubCategoryClient = ({
  categories,
  category,
  categorySeoDetails,
  categorySlug,
  initialProducts,
  parentCategories,
  parentCategoryName,
  parentSlug,
  priceRange,
  productsCount,
  subCategories,
  subCategorySlug
}) => {
  const surface = GetUiDeviceSurface();

  const breadcrumbsInfo = useMemo(() => {
    const baseCrumbs = [
      {
        link: getPageURL({ pageName: ROUTE_CONFIG.HOME_PAGE.label }),
        name: 'Home'
      },
      {
        link: getPageURL({
          pageName: ROUTE_CONFIG.L0_CATEGORY.label,
          pathParams: { parentSlug }
        }),
        name: parentCategoryName
      }
    ];

    const currentL1 = categories?.find((cat) => cat.slug === categorySlug);
    if (currentL1) {
      baseCrumbs.push({
        link: getPageURL({
          pageName: ROUTE_CONFIG.L1_CATEGORY.label,
          pathParams: { categorySlug, parentSlug }
        }),
        name: currentL1.name
      });

      const currentL2 = currentL1.childCategories?.find(
        (sub) => sub.slug === subCategorySlug
      );
      if (currentL2) {
        baseCrumbs.push({
          link: getPageURL({
            pageName: ROUTE_CONFIG.L2_CATEGORY.label,
            pathParams: { categorySlug, parentSlug, subCategorySlug }
          }),
          name: currentL2.name
        });
      }
    }
    return baseCrumbs;
  }, [
    categorySlug,
    subCategorySlug,
    parentSlug,
    parentCategoryName,
    categories
  ]);

  const categoryLayoutMap = {
    [DEVICE_SURFACE.MOBILE]: CategoryMobileLayoutTemplate,
    [DEVICE_SURFACE.WEB]: CategoryDesktopLayoutTemplate
  };

  const CategoryLayout =
    categoryLayoutMap[surface] || CategoryDesktopLayoutTemplate;

  return (
    <CategoryLayout
      {...{
        breadcrumbsInfo,
        categories,
        category,
        categorySeoDetails,
        categorySlug,
        initialProducts,
        parentCategories,
        parentCategoryName,
        parentSlug,
        priceRange,
        productsCount,
        showProductSubCategory: true,
        subCategories,
        subCategorySlug
      }}
    />
  );
};

export default ChildSubCategoryClient;
